export const TREND_OPERATING_INCOME = [
  { value: 'FA062', color: '#006AA6' },
  { value: 'IS111', color: '#B3CC85' },
  { value: 'IS114', color: '#74B49A' },
  { value: 'FA063', color: '#00A8B5' },
  { value: 'FA064', color: '#ABEDCB' },
]

export const TREND_GAIN_PROPRIETARY_TRADING = [
  { value: 'IS106', color: '#F5CBA3' },
  { value: 'IS110', color: '#F49966' },
  { value: 'IS112', color: '#C06C84' },
]

export const EACH_YEAR = {
  OPERATING_INCOME_BREAKDOWN: [
    { id: 'FA155', color: '#006AA6' },
    { id: 'FA065', color: '#FFCD60' },
    { id: 'FA066', color: '#00A8B5' },
    { id: 'FA067', color: '#C06C84' },
    { id: 'FA068', color: '#74B49A' },
    { id: 'FA069', color: '#7F63B9' },
  ],
  GAIN_PROPRIETARY_TRADING_BREAKDOWN: [
    { id: 'FA070', color: '#006AA6' },
    { id: 'FA071', color: '#F49966' },
    { id: 'FA072', color: '#00A8B5' },
  ],
}

export const TABLE_TABS = [
  {
    label: 'financialAnalysis.OPERATING_INCOME_BREAKDOWN',
    key: 0,
    rowIds: [
      'FA062',
      'IS111',
      'IS114',
      'FA063',
      'FA064',
      'IS3',
      'FA091',
      'BS64',
      'RT0172',
    ],
  },
  {
    label: 'financialAnalysis.GAIN_PROPRIETARY_TRADING_BREAKDOWN',
    key: 1,
    rowIds: ['IS106', 'IS110', 'IS112', 'FA099'],
  },
]
